import styled from 'styled-components'
import theme from 'theme_'

export const MobileWhiteCardLineContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const MobileWhiteCardLineLabel = styled.div`
  color: ${theme.colors.darkeyGrey};
  min-width: 35%;
  margin-right: 10px;
`

export const MobileWhiteCardLineValue = styled.div`
  word-break: break-word;
`
